/*

*/
import React from 'react'

const FacebookIcon = (props) => {
    const { name = "", size = "s", color = '#fff', className = "" } = props;

    return (
        <svg className={('icon', name) + " " + className} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="24" height="24" fill="white" />
            <path d="M21 12.055C21 7.05407 16.9706 3 12 3C7.02944 3 3 7.05407 3 12.055C3 16.5746 6.29117 20.3207 10.5938 21V14.6725H8.30859V12.055H10.5938V10.0601C10.5938 7.79067 11.9374 6.53712 13.9932 6.53712C14.9779 6.53712 16.0078 6.71397 16.0078 6.71397V8.94236H14.8729C13.7549 8.94236 13.4062 9.64035 13.4062 10.3565V12.055H15.9023L15.5033 14.6725H13.4062V21C17.7088 20.3207 21 16.5746 21 12.055Z" fill="#1877F2" />
        </svg>
    )
};

export default FacebookIcon
